import { useContext } from "react";

import { useParams } from "next/navigation";

import { GlobalPathParams } from "~/app/[locale]/types";
import { DictionaryLabelContext } from "~/context/dictionary-label/context";
import { DictionaryKeys } from "~/context/dictionary-label/types";
import { getProductPricePerUnitText } from "~/utils/get-product-price-per-unit-text";

export const useProductPricePerUnitText = ({
  measureOfPrice,
  uomOfPrice,
  pricePerUnit,
}: {
  measureOfPrice?: number | null;
  uomOfPrice?: string | null;
  pricePerUnit?: number | null;
}): string | null => {
  const { locale } = useParams<GlobalPathParams>();
  const unitTranslation = useContext(DictionaryLabelContext)?.[DictionaryKeys.Unit];

  return getProductPricePerUnitText({
    measureOfPrice,
    uomOfPrice,
    pricePerUnit: pricePerUnit as number,
    unitTranslation,
    locale,
  });
};
